// Notifications in the menu sheet's Settings (FE-51): each kind its own switch, a test, the way to
// turn them off, and a short "Not getting notifications?" for the usual reasons. Nothing at all
// where push can't be offered (inside the Lagos Life frame, a distributor's player, a server with no
// key, a browser with no push).
import { useEffect, useState } from 'react';
import {
  onPush,
  PUSH_KINDS,
  pushOffered,
  pushView,
  refreshPush,
  sendTest,
  setKind,
  turnOff,
  turnOn,
} from '../lib/push';
import { useUi } from '../store/ui';
import { S } from '../strings';
import { Icon } from './icons';

const say = (notice: string) => useUi.getState().set({ notice, noticeTone: 'info' });

export function PushSettings() {
  const [view, setView] = useState(pushView);
  useEffect(() => onPush(setView), []);
  useEffect(() => {
    if (pushOffered()) void refreshPush();
  }, []);
  if (view.status === 'none') return null;
  const chip = (on: boolean, label: string, onClick: () => void) => (
    <button
      key={label}
      type="button"
      className={`chip${on ? ' is-on' : ''}`}
      aria-pressed={on}
      disabled={view.busy}
      onClick={onClick}
    >
      {label}
    </button>
  );
  return (
    <>
      <li className="sheet__section">
        <Icon name="bell" size={16} />
        {S.push.title}
      </li>
      {view.status === 'install' && <li className="sheet__note">{S.push.iphone}</li>}
      {view.status === 'blocked' && <li className="sheet__note">{S.push.blocked}</li>}
      {(view.status === 'ask' || view.status === 'off') && (
        <li className="sheet__row">
          <span>{S.push.title}</span>
          <button
            type="button"
            className="chip"
            disabled={view.busy}
            onClick={() =>
              turnOn()
                .then((s) => s === 'blocked' && say(S.push.denied))
                .catch(() => say(S.push.failed))
            }
          >
            {S.push.turnOn}
          </button>
        </li>
      )}
      {view.status === 'on' && (
        <>
          {PUSH_KINDS.map((k) => {
            const on = view.kinds.includes(k);
            const name = S.push.kinds[k] ?? k;
            return (
              <li key={k} className="sheet__row push-row">
                <span className="push-row__text">
                  <span>{name}</span>
                  <small>{S.push.notes[k]}</small>
                </span>
                <fieldset className="row push-row__chips" aria-label={name}>
                  {chip(on, S.push.on, () => !on && setKind(k, true).catch(() => say(S.push.failed)))}
                  {chip(!on, S.push.off, () => on && setKind(k, false).catch(() => say(S.push.failed)))}
                </fieldset>
              </li>
            );
          })}
          <li className="sheet__row push-row__actions">
            <button
              type="button"
              className="chip"
              disabled={view.busy}
              onClick={() =>
                sendTest()
                  .then(() => say(S.push.testSent))
                  .catch(() => say(S.push.failed))
              }
            >
              {S.push.test}
            </button>
            <button type="button" className="chip" disabled={view.busy} onClick={() => void turnOff()}>
              {S.push.turnOff}
            </button>
          </li>
        </>
      )}
      <li className="sheet__note">
        <details className="push-help">
          <summary>{S.push.help}</summary>
          <ul>
            {S.push.helpItems.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        </details>
      </li>
    </>
  );
}
